import React from 'react';
import { FormattedMessage } from 'react-intl';
import { StateType } from '../../../state/reducers';
import styles from './search_header_status.module.scss';

function formatTime(time: number) {
  return (time / 1000).toFixed(2).replace('.', ',');
}

const SEARCH_TYPE_ENTITY_MAP = {
  arret: 'search/SearchHeaderStatus.tsx/1',
  commentary: 'search/SearchHeaderStatus.tsx/2',
  law: 'search/SearchHeaderStatus.tsx/3',
  lawyer: 'search/SearchHeaderStatus.tsx/4',
  enterprise: 'search/SearchHeaderStatus.tsx/5',
  preparatory_work: 'search/SearchHeaderStatus.tsx/8',
} as const;

type Props = {
  totalHits: StateType['results']['totalHits'];
  searchTime: StateType['results']['searchTime'];
  type: StateType['queryParams']['type'];
};

export const SearchHeaderStatus: React.FunctionComponent<Props> = ({
  totalHits,
  searchTime,
  type,
}) => {
  const parsedTotalHits = Math.floor(totalHits);
  const isMaxExceeded = totalHits > parsedTotalHits;
  return (
    <span className={styles.headerStatus}>
      <FormattedMessage
        id={
          isMaxExceeded
            ? 'search/SearchHeaderStatus.tsx/6'
            : 'search/SearchHeaderStatus.tsx/7'
        }
        values={{
          totalHits: parsedTotalHits,
          searchTime: formatTime(searchTime),
          entity: (
            <FormattedMessage
              id={SEARCH_TYPE_ENTITY_MAP[type]}
              values={{
                totalHits: parsedTotalHits,
                searchTime: formatTime(searchTime),
              }}
            />
          ),
        }}
      />
    </span>
  );
};
